// Copyright (c) 2020-2026 Life and Soft

import { combineReducers } from "redux";

import authReducer from "./authReducer";
import errorReducer from "./errorReducer";
import configurationReducer from "./configurationReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  errors: errorReducer,
  configuration: configurationReducer,
});

export default rootReducer;
